module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKdJREFUeNpiYBgFIw/8///fAIjPA/F9IE4gQi1IHQj0E2tBw39UkIDH8PdoahXQ1TERYed8dEtAhgOp/UAsQE4QCUCD6D82n+Bw+X9CwUmsJQ0UG06EJZQbToIlCdRItg44DJ9PrTzxnlbBQ8hwiiIYl+EF+JIwsYYr4EuKhPIJMRYUENKMxxIDYoOHmLIImyUOpCRNUK4NICKf7Icavn+0LhqcACDAAHkNP1eH8c5MAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/close-dialog.png
// module id = 2321
// module chunks = 1